<ng-container>
  <div class="wrapper__form">
    <div
      class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
      <h2 class="wrapper__form__title h4-tipografia-govco mb-0">
        {{ proconText['tramite-sic-procon']['fundamentos-derecho'] }}
      </h2>
    </div>
    <form [formGroup]="formFundamentos" class="row g-3">
      <div class="col-12 col-xl-12">
        <textarea
          [disabled]="true"
          id="fundamentosDerechos"
          class="form-control"
          rows="5"
          formControlName="fundamentosDerechos"
          [readonly]="true"
          style="resize: none; background-color: #f0f0f0"
          [ngClass]="{
            'is-invalid':
              formFundamentos.get('fundamentosDerechos')?.invalid &&
              formFundamentos.get('fundamentosDerechos')?.touched,
          }"></textarea>
      </div>
    </form>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        aria-label="Atrás">
        {{ proconText['botones-envio']['atras'] }}
      </button>

      <button
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        [disabled]="formFundamentos.invalid"
        (click)="pasarAPruebas($event, true)"
        aria-label="Guardar sin enviar">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="onClickFundamentos($event)"
        aria-label="Siguiente">
        {{ proconText['siguiente'] }}
      </button>
    </div>
  </div>
</ng-container>
